import React from 'react';
import BackButton from './BackButton';

function SavedPatentsPage({ setPage, viewSavedPatents, handleUnsavePatent }) {
  const getPatentUrl = (patentNumber) => {
    return "https://worldwide.espacenet.com/patent/search?q=pn%3D" + patentNumber;
  };

  return (
    <div style={{ minHeight: '100vh', background: 'white' }}>
      <header style={{ padding: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <BackButton onClick={() => setPage('search')} />
          <img
            src="/logo.svg"
            alt="PatTrak Logo"
            style={{
              height: '32px',
              cursor: 'pointer'
            }}
            onClick={() => setPage('search')}
          />
        </div>
        <div style={{ display: 'flex', gap: '16px' }}>
        </div>
      </header>

      <main style={{ maxWidth: '800px', margin: '80px auto', padding: '0 16px' }}>
        <h1 style={{ fontSize: '36px', fontWeight: 'bold', color: '#1d2934', marginBottom: '16px' }}>
          Saved Patents
        </h1>

        {viewSavedPatents.length === 0 ? (
          <p style={{ fontSize: '16px', color: '#5e778a' }}>You haven't saved any patents yet.</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {viewSavedPatents.map((patent) => (
              <div key={patent.patent_number} style={{ border: '1px solid #5e778a', padding: '16px', borderRadius: '8px' }}>
                <h3 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '8px' }}>
                  <a
                    href={getPatentUrl(patent.patent_number)}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#53dafc', textDecoration: 'none' }}
                  >
                    {patent.patent_number} →
                  </a>
                </h3>
                <p style={{ fontSize: '18px', color: '#474f58' }}>{patent.title}</p>
                <p style={{ fontSize: '14px', color: '#5e778a', marginTop: '8px' }}>{patent.abstract}</p>
                <div style={{ marginTop: '8px' }}>
                  <span style={{ fontSize: '14px', color: '#545f6b' }}>
                    Assignee: {patent.assignee} | Saved: {patent.saved_at}
                  </span>
                </div>

                <button
                  onClick={() => handleUnsavePatent(patent.patent_number)}
                  style={{
                    background: '#ff4444',
                    color: 'white',
                    border: 'none',
                    padding: '8px 16px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '600',
                    marginTop: '12px'
                  }}
                >
                  Remove from Saved
                </button>
              </div>
            ))}
          </div>
        )}
      </main>

      <footer style={{
        padding: '32px 16px',
        textAlign: 'center',
        borderTop: '1px solid #e0e0e0',
        marginTop: '80px',
        color: '#5e778a',
        fontSize: '14px'
      }}>
        By using Patent Tracker, you agree to our{' '}
        <a href="#" style={{ color: '#53dafc', textDecoration: 'none' }}>Terms</a>
        {' '}and have read our{' '}
        <a href="#" style={{ color: '#53dafc', textDecoration: 'none' }}>Privacy Policy</a>
        . See{' '}
        <a href="#" style={{ color: '#53dafc', textDecoration: 'none' }}>Cookie Preferences</a>.
      </footer>
    </div>
  );
}

export default SavedPatentsPage;